import React from "react"
import Button from "components/common/Button"
import Text from "components/text"
import FormInput from "components/form/input"
import Panel from "components/panel"
import "./index.scss"

const ChangePasswordForm = ({
  old_password,
  new_password1,
  new_password2,
  changePassword,
  handleChange,
  error,
  loading,
}) => {
  return (
    <div className="change-password">
      <Panel pad="40" grid>
        <Text type="headline" text="Change Password" />
        <FormInput
          type="password"
          label={"Current Password"}
          name={"old_password"}
          value={old_password}
          handleChange={handleChange}
          error={error.old_password}
        />

        <FormInput
          type="password"
          label={"New Password"}
          name={"new_password1"}
          value={new_password1}
          handleChange={handleChange}
          error={error.new_password1}
        />

        <FormInput
          type="password"
          label={"Confirm Password"}
          name={"new_password2"}
          value={new_password2}
          handleChange={handleChange}
          error={error.new_password2}
        />
        <Button
          label="Update Password"
          size="large"
          onClick={changePassword}
          loading={loading}
        />
      </Panel>
    </div>
  )
}

export default ChangePasswordForm
